import { ValidationMessage } from 'ui';
import { ComplexValue } from 'app/types-shared';
import { UserMembersActionType } from './constants';

export interface CodeField {
  id: number;
  label: string;
  searchRequired: boolean;
}

export interface ListBranchModel {
  subscriberGroup?: number;
  negated?: boolean;
  showAll?: boolean;
  name?: string;
  email?: { specifiedText: { text: string } };
  hideDisabledUsers?: boolean;
}

export interface ListBranchItem {
  id: number;
  description: string;
  email?: string;
  subscriberGroup?: ComplexValue<number>[];
  disabled?: Date;
}

export interface ListBranch {
  id: number;
  items: ListBranchItem[];
  numberOfResults: number;
}

export interface ListBranchState {
  id: number;
  fetching: boolean;
  open: boolean;
}

export interface ListAction {
  path: number[];
  propagate: boolean;
  type: UserMembersActionType;
}

export enum Visibility {
  all = 'all',
  selected = 'selected',
  unselected = 'unselected'
}

export interface UserMembersState {
  requestedModel: ListBranchModel;
  listBranch: ListBranch[];
  listBranchState: ListBranchState[];

  listActions: ListAction[];
  updating: boolean;
  actionErrors: ValidationMessage[];
  activeValueError: ValidationMessage;

  subscriberGroup: ComplexValue<number>;

  visiblity: Visibility;
  lastSelectedRow: number;
  selectedRows: number[][];
}
